import React, { useState, useEffect } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import { showErrorAlert } from "../../../../../customComponents/CustomSweetAlert/errorsweetalert";
import Loader from "../../../../../customComponents/CustomLoader";
import { showAlert } from "../../../../../customComponents/CustomSweetAlert/ShowAlert";
import { buttonStyle, isFormValid } from "../../../../../../helpers/common";
import validations from "../../../../../../helpers/validations";

const AddModel = () => {
  const [formData, setFormData] = useState({});
  const [productOptions, setProductOptions] = useState([]);
  const [subproductOptions, setSubproductOptions] = useState([]);
  const [makeOptions, setMakeOptions] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const [loading, setLoading] = useState(false);
  const [colorOptions, setColorOptions] = useState([]);
  const [userTypedd, setUserTypedd] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id");

  const ModelInputs = [
    {
      name: "productName",
      label: "Product Name",
      type: "dropdown",
      options: productOptions,
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "model",
      label: "Model",
      placeholder: "Enter Model Name",
      type: "text",
      required: true,
      validation: validations.model({ required: true }),
      gridClass: "col-lg-4",
    },
    {
      name: "description",
      placeholder: "Enter Model Description",
      label: "Description",
      type: "text",
      required: true,
      validation: validations.description({ required: true }),
      gridClass: "col-lg-4",
    },
    {
      name: "colour_id_list",
      label: "Color Name",
      type: "multiselectdropdownStockin",
      options: colorOptions,
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",

      gridClass: "col-lg-4",
    },
  ];

  useEffect(() => {
    fetchColorOptions();
  }, []);

  const fetchColorOptions = async () => {
    try {
      const payload = {};
      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post("/color/ddlcolor", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const options = response.data.data.data.map((color) => ({
        label: color.NAME,
        value: color.ID,
      }));

      setColorOptions(options);
    } catch (error) {
      console.error("Error fetching color options:", error);
    }
  };

  const fetchProductOptions = async () => {
    try {
      const response = await axiosInstance.post(
        "/product/ddlproduct",
        {
          orderBy: "product_id desc",
          page: 0,
          pageSize: 100, // Adjust as needed
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((product) => ({
        label: product.NAME,
        value: product.ID,
      }));

      setProductOptions(options);
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  const fetchMakeOptions = async (subproductId) => {
    try {
      const response = await axiosInstance.post(
        "/make/ddlmake",
        {
          orderBy: "make_id desc",
          page: 0,
          pageSize: 100,
          subproduct_id: subproductId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      const options = response.data.data.data.map((make) => ({
        label: make.NAME,
        value: make.ID,
      }));

      setMakeOptions(options);
    } catch (error) {
      console.error("Error fetching make options:", error);
    }
  };

  useEffect(() => {
    fetchProductOptions();
  }, []);

  useEffect(() => {
    if (formData.productName) {
      const productId = formData.productName;

      if (productId) {
        // fetchSubproductOptions(productId);
        setSubproductOptions([]);
        setMakeOptions([]);
      }
    }
  }, [formData.productName]);

  useEffect(() => {
    console.log("subproductformdata", formData);
    if (formData.subproductName) {
      const subproductId = formData.subproductName;
      if (subproductId) {
        fetchMakeOptions(subproductId);
        setMakeOptions([]);
      }
    }
  }, [formData.subproductName]);

  const handleFormSubmit = async () => {
    // Validate form before submission
    const errors = {};
    let isValid = true;

    ModelInputs.forEach((field) => {
      if (field.required && !formData[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      }
      if (
        field.validation?.pattern &&
        !field.validation.pattern.test(formData[field.name])
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
      } else if (
        field.required &&
        field.validation &&
        field.validation.pattern &&
        !field.validation.pattern.test(formData[field.name])
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });

    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    // Show confirmation dialog using the reusable alert
    const confirmation = await showAlert({
      title: "Confirmation",
      text: "Are you sure you want to add this record in Model?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    // If the user cancels, exit early
    if (!confirmation.isConfirmed) {
      return;
    }

    try {
      setLoading(true);

      const payload = {
        product_id: formData.productName,
        subproduct_id: formData.subproductName,
        // make_id: formData.make,
        model_desc: formData.description,
        model_name: formData.model,
        colour_id_list: formData.colour_id_list,
        status: formData.status === true ? 1 : 0,
      };

      // API request to create the new model
      const response = await axiosInstance.post("/model/create", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      console.log("API Response:", response.data);

      // Show success alert using the reusable alert
      if (response.status === 200) {
        await showAlert({
          title: "Success",
          text: "Model added successfully.",
          icon: "success",
          confirmButtonText: "OK",
        });

        // Navigate to model management page after success
        navigate("/admin/manage-product/model");
      }
    } catch (error) {
      console.error("Error submitting form:", error);

      // Show error alert using the reusable alert
      const errorMessage =
        error.response?.data?.message ||
        "An error occurred while processing your request.";
      showAlert({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img
                style={{ cursor: "pointer" }}
                onClick={() => navigate(-1)}
                src={backicon}
                alt="back"
              />
              <span className="backbtntitle">Add Model</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Enter Model Details
              </span>
              <DynamicForm
                formConfig={ModelInputs}
                formData={formData}
                setFormData={setFormData}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                className="submit-btn"
                disabled={
                  !isFormValid(ModelInputs, formData, validationErrors) ||
                  loading
                }
                style={buttonStyle(
                  ModelInputs,
                  formData,
                  validationErrors,
                  loading,
                )}
                onClick={handleFormSubmit}
              >
                {loading ? "Processing..." : "Submit"}
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AddModel;
